import { useEffect, useState } from "react";
import { gridLetters, chaupayian } from "../assets/constants";

const Grid = ({ handleNotificationClick, history, setHistory }) => {
  const [chaupai, setchaupai] = useState(null);

  const handleLetterClick = (idx) => {
    setchaupai(chaupayian[idx % 9]);

    let currenttime = new Date();
    let currentdate = currenttime.toDateString();
    let _id = Date.now();

    if (localStorage.getItem("history")) {
      let myhistory = JSON.parse(localStorage.getItem("history"));
      localStorage.setItem(
        "history",
        JSON.stringify([
          ...myhistory,
          {
            ...chaupayian[idx % 9],
            _id: _id,
            time: currenttime,
            date: currentdate,
            title: `फल_${_id}`,
          },
        ])
      );
      setHistory([
        ...myhistory,
        {
          ...chaupayian[idx % 9],
          _id: _id,
          time: currenttime,
          date: currentdate,
          title: `फल_${_id}`,
        },
      ]);
    } else {
      let entry = {
        ...chaupayian[idx % 9],
        _id: _id,
        time: currenttime,
        date: currentdate,
        title: `फल_${_id}`,
      };
      localStorage.setItem("history", JSON.stringify([entry]));
      setHistory([entry]);
    }

    handleNotificationClick("Aapka karya Fal", chaupayian[idx % 9].fal);

    document.getElementById("answer")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="w-full flex flex-col items-center px-2">
      <span className="text-sm md:text-md font-bold mb-3">
        किसी एक अक्षर पर क्लिक करे
      </span>

      <div className="flex justify-center items-center w-full md:w-auto p-2 md:p-4">
        <div
          className="
            p-2 rounded-xl bg-[#ebdbdd]   
            shadow-[0_0_12px_rgba(169,161,175,0.4)]
            w-full max-w-[700px]
          "
        >
          <div
            className="
              grid grid-cols-[repeat(15,minmax(0,1fr))] 
              text-[10px] sm:text-xs md:text-base 
              gap-[2px] sm:gap-[3px] p-[4px] sm:p-[6px] md:p-[8px]
              border-2 border-[#a2949b] rounded-lg
              bg-[#c9a1b1]
              w-full
            "
          >
            {gridLetters.map((letter, idx) => {
              return (
                <span
                  key={idx}
                  onClick={() => handleLetterClick(idx)}
                  className="
                    flex justify-center items-center
                    w-6 h-6 sm:w-7 sm:h-7 md:w-[32px] md:h-[32px]
                    text-[8px] sm:text-[10px] md:text-[16px] font-semibold
                    text-[#363259] bg-[#ebdbdd] border border-[#a8a1af] rounded
                    transition transform duration-200 ease-in-out
                    select-none
                    hover:scale-110 hover:bg-[#ad819a] hover:shadow-[0_2px_6px_rgba(124,116,147,0.4)]
                    cursor-pointer
                  "
                >
                  {letter}
                </span>
              );
            })}
          </div>
        </div>
      </div>

      <div id="answer" className="w-full flex justify-center">
        {chaupai && (
          <div
            id="answer-div"
            className="
              flex justify-center flex-col w-full max-w-[700px] text-left 
              my-4 md:my-5 px-3 md:px-4 py-3 
              rounded-xl border-2 shadow-[0_0_10px_rgba(54,50,89,0.2)]
              bg-[#ebdbdd] border-[#a2949b] text-[#363259]
            "
          >
            <span className="font-bold text-center text-[#363259] text-base md:text-lg mb-3">
              फल
            </span>

            <table className="table-auto w-full text-xs sm:text-sm md:text-base">
              <tbody>
                <tr className="border-t border-[#a8a1af]">
                  <td className="font-bold py-2 text-[#363259]">चौपाई:</td>
                  <td className="py-2">{chaupai.chaupai}</td>
                </tr>

                <tr className="border-t border-[#a8a1af]">
                  <td className="font-bold py-2 text-[#363259]">अर्थ:</td>
                  <td className="py-2">{chaupai.context}</td>
                </tr>

                <tr className="border-t border-b border-[#a8a1af]">
                  <td className="font-bold py-2 text-[#363259]">फल:</td>
                  <td className="py-2">{chaupai.fal}</td>
                </tr>
              </tbody>
            </table>
          </div>
        )}
      </div>

      <div
        id="know-more"
        className="
          my-4 text-sm sm:text-base text-left 
          w-full max-w-[650px] md:my-7 border-b px-3 md:px-5
        "
      >
        <h3 className="font-semibold text-base md:text-lg my-3">
          श्री राम शलाका क्या है?
        </h3>
        <p className="mb-3">
          श्री राम शलाका प्रश्नावली एक अद्भुत उपकरण है, जो गोस्वामी तुलसीदास जी
          की रचना श्री रामचरितमानस पर आधारित है और जीवन के रहस्यों को सुलझाने,
          आत्मविश्वास व आस्था को बढ़ाने में सहायक है। इसमें 15×15 का एक ग्रिड
          होता है, जिसमें बालकाण्ड और सुन्दरकाण्ड की 9 चौपाइयों के अक्षर लिखे
          होते हैं। इन अक्षरों के प्रयोग से चौपाई बनती है, जो आपके प्रश्न का
          उत्तर देती है और जीवन को खुशहाल व सफल बनाने में मार्गदर्शन प्रदान करती
          है।
        </p>

        <h3 className="font-semibold text-base md:text-lg my-3">
          श्री राम शलाका का उपयोग?
        </h3>
        <p>
          श्री राम शलाका प्रश्नावली का उपयोग बहुत ही सरल है—बस मन में प्रश्न
          रखकर ग्रिड में किसी भी अक्षर पर उंगली रखें, फिर उस अक्षर से प्रत्येक
          9वें अक्षर को जोड़कर एक चौपाई बनती है जो आपके प्रश्न का उत्तर देती है
          और उसका अर्थ भी जाना जा सकता है। इसके माध्यम से जीवन की समस्याओं का
          समाधान पाने के साथ-साथ भगवान श्री राम का आशीर्वाद मिलता है, जिससे मन
          शांत और प्रसन्न होता है तथा व्यक्ति अपने लक्ष्य की ओर अग्रसर होता है।
        </p>
      </div>
    </div>
  );
};

export default Grid;
